import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'

@ngCore.Injectable({ providedIn: 'root' })
export class Api {
  /**
   * Retrieves all models in the current context
   *
   * If no context is passed, just returns an empty list
   */
  public getModels(
    context: ents.core.admin.Context.ForZone,
  ): rxjs.Observable<ents.core.dms.models.Model[]> {
    return gql.queries.models.execute(context)
  }
}
